export default "__VITE_ASSET__86dca4d8__"